import type {Color} from "#render-nodes/shader-expr"

export function defaultMaterialColor(materialIndex: number): Color {
    const colorPalette: Color[] = [
        [0.658824, 0.901961, 0.807843],
        [0.862745, 0.929412, 0.760784],
        [1.0, 0.827451, 0.709804],
        [1.0, 0.54902, 0.580392],
        [0.898039, 0.988235, 0.760784],
        [0.615686, 0.878431, 0.678431],
        [0.270588, 0.678431, 0.658824],
        [0.329412, 0.47451, 0.501961],
        [0.34902, 0.309804, 0.309804],
        [0.964706, 0.447059, 0.501961],
        [0.752941, 0.423529, 0.517647],
        [0.423529, 0.356863, 0.482353],
        [0.207843, 0.360784, 0.490196],
        [0.909804, 0.0901961, 0.364706],
        [0.968627, 0.858824, 0.309804],
        [0.941176, 0.894118, 0.894118],
        [0.980392, 0.85098, 0.756863],
        [0.0, 0.588235, 0.533333],
        [0.482353, 0.752941, 0.262745],
        [0.0117647, 0.572549, 0.811765],
    ]
    return colorPalette[materialIndex % colorPalette.length]
}

export type DefaultMaterialParameters = {
    color: Color
    roughness: number
    metalness: number
}

// what a slot without a material shows, in the viewer, the renderer and Blender alike
export function defaultMaterialParameters(materialIndex: number): DefaultMaterialParameters {
    return {color: defaultMaterialColor(materialIndex), roughness: 0.8, metalness: 0}
}
